import { Box, Flex, HStack, Link, Text } from '@chakra-ui/react';
import { headingFont } from 'theme/tokens';
import { translate } from 'i18n';

export default function MarketingHeader() {
  return (
    <Box
      as="header"
      position="sticky"
      top={0}
      zIndex={100}
      bg="white"
      borderBottom="1px solid"
      borderColor="gray.100"
      px={{ base: 4, md: 8 }}
      py={3}
    >
      <Flex maxW="1200px" mx="auto" align="center" justify="space-between">
        <HStack spacing={2}>
          <Text
            fontFamily={headingFont}
            fontWeight="800"
            fontSize="xl"
            bgGradient="linear(to-r, brand.500, accent.500)"
            bgClip="text"
          >
            MySportSet
          </Text>
        </HStack>

        <HStack spacing={6}>
          <Link
            href="#/marketing/roi-calculator"
            fontWeight="500"
            fontSize="sm"
            color="gray.600"
            _hover={{ color: 'brand.500' }}
          >
            {translate('marketing.nav_roi_calculator')}
          </Link>
          <Link
            href="#/marketing/migration-kit"
            fontWeight="500"
            fontSize="sm"
            color="gray.600"
            _hover={{ color: 'brand.500' }}
          >
            {translate('marketing.nav_migration_kit')}
          </Link>
          <Link
            href="#/marketing/referral"
            fontWeight="500"
            fontSize="sm"
            color="gray.600"
            _hover={{ color: 'brand.500' }}
            display={{ base: 'none', md: 'block' }}
          >
            {translate('marketing.nav_referral')}
          </Link>
          <Link
            href="#/auth/sign-in"
            fontWeight="500"
            fontSize="sm"
            color="gray.600"
            _hover={{ color: 'brand.500' }}
          >
            {translate('marketing.sign_in')}
          </Link>
          <Link
            href="#/auth/sign-up"
            bg="brand.500"
            color="white"
            px={4}
            py={2}
            borderRadius="full"
            fontWeight="600"
            fontSize="sm"
            _hover={{ bg: 'brand.600', textDecoration: 'none' }}
          >
            {translate('marketing.start_free_trial')}
          </Link>
        </HStack>
      </Flex>
    </Box>
  );
}
